import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { EnvState } from '../../shared/helpers/env-state';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageText, ToastService } from 'app/helpers/services/toastService';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {
  constructor(
    private env: EnvState,
    private router: Router,
    private toastService: ToastService,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Relative URLs missing the leading slash would concatenate into
    // "<apiUrl>api/..." (e.g. "/coreapi/..." behind the server's virtual
    // folder) - normalize them before prepending the base url.
    let requestUrl = request.url;
    if (!requestUrl.startsWith('/') && !requestUrl.startsWith('http')) {
      requestUrl = `/${requestUrl}`;
    }

    const apiReq = request.url.startsWith('https://api.openai.com')
      ? request
      : request.clone({ url: `${this.env.apiUrl}${requestUrl}` });
    // this.toastService.showSuccess(MessageText.success);
    // this.toastService.showError(MessageText.success);
    return next.handle(apiReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 401 &&
          !window.location.href.includes('office365auth')
        ) {
          this.router.navigate(['signin']);
        }
        if (error.status === 403) {
          this.router.navigate(['unauthorized']);
        }

        if (
          error.status === 404 &&
          !apiReq.url.includes('/repository/tenant-custom-descriptions')
        ) {
          //this.router.navigate(['pagenotfound']);
        }

        if (error?.error?.detail?.startsWith('IsCustom.')) {
          this.toastService.showError(error.error.detail.substring(9));
        }

        return throwError(error);
      }),
    );
  }
}
